export default __webpack_public_path__ + "static/media/signup-icon.68005c07.svg";